module.exports = __webpack_public_path__ + "static/media/MaksIcon.950432c1.svg";